<template>
  <material-card color="primary">
    <template v-slot:headActions>
      <v-icon @click="remove" class="remove-icon" color="grey">
        mdi-delete-forever
      </v-icon>
    </template>
    <v-container class="py-0">
      <v-img :src="image.image_url" />
    </v-container>
  </material-card>
</template>
<script>

export default {
  name: 'ImageItem',
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
  methods: {
    remove () {
      this.$emit('removed', this.image.id)
    },
  },
}
</script>
<style scoped>
.remove-icon {
  cursor: pointer;
  opacity: 0.7
}
.remove-icon:hover {
  opacity: 1;
}
</style>
